import { Task } from '@/tracker/types';
import { parseDuration } from '@/utils/parseDuration';

/** Импортированный `spent` бывает отрицательным — на полосе это ноль */
const toMinutes = (duration: string | null) =>
  !duration || duration.startsWith('-') ? 0 : parseDuration(duration);

/**
 * Полоса прогресса, как в Яндекс Трекере: затрачено / (затрачено + осталось).
 * Перерасход — затрачено больше общей оценки. null — остатка нет, полосу не показываем
 */
export const getProgress = (issue: Task) => {
  if (issue.estimation === null) return null;

  const spent = toMinutes(issue.spent);
  const total = spent + toMinutes(issue.estimation);
  const original = toMinutes(issue.originalEstimation);

  return {
    percent: total ? Math.round((spent / total) * 100) : 0,
    isOverrun: original > 0 && spent > original,
  };
};
